import { Stack, TextField, Typography } from '@mui/material';
import { useFormContext, Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { IntakeExtendedLineItemsCheckStepFormData } from '../IntakeExtendedLineItemsCheckStep.schema';
import { I18nNamespace } from '@/legacy/common/types';

export const ReasonInput = () => {
  const { t } = useTranslation(I18nNamespace.intake, { keyPrefix: 'IntakeExtendedLineItemsCheckStep' });
  const {
    control,
    formState: { errors },
  } = useFormContext<IntakeExtendedLineItemsCheckStepFormData>();

  return (
    <Stack spacing={2} maxWidth={'100%'}>
      <Typography variant="subtitle2" color={errors.reasonNotSelect ? 'error' : 'textPrimary'}>
        {t('reasonForNoSelection')}
      </Typography>
      <Controller
        name="reasonNotSelect"
        control={control}
        render={({ field }) => (
          <TextField
            {...field}
            value={typeof field.value === 'string' ? field.value : ''}
            label={t('reasonLabel')}
            placeholder={t('reasonPlaceholder')}
            multiline
            minRows={3}
            fullWidth
          />
        )}
      />
    </Stack>
  );
};
